interface TranslatedCaption {
  translations?: { value?: string }[];
}

// The simple endpoints return captions as plain strings, though the spec types them as `object`.
export const captionText = (caption: unknown): string => {
  if (typeof caption === 'string') {
    return caption;
  }
  if (typeof caption === 'object' && caption !== null && 'translations' in caption) {
    return (caption as TranslatedCaption).translations?.[0]?.value ?? '';
  }
  return '';
};
